<template>
    <v-container>
        <form>
            <v-row>
                <v-col v-for="(currency, index) in Object.keys(currency_list)" v-bind:key="index">
                    <v-text-field
                        v-model="currency_list[currency]"
                        :label="currency"
                        type="number"
                        step="0.01"
                        color="primary"
                        outlined
                        small
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                    <TimePicker :model.sync="start" label="Начало" :outlined="true"></TimePicker>
                </v-col>
                <v-col cols="3">
                    <TimePicker :model.sync="end" label="Конец" :outlined="true"></TimePicker>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        v-model="cohors"
                        label="Когорта (дни)"
                        v-validate="'required|max:50'"
                        color="primary"
                        outlined
                        small
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="utm_source"
                        :items="utm_sources"
                        label="utm_source"
                        color="primary"
                        clearable
                        outlined
                        small-chips
                        chips
                        deletable-chips
                        multiple
                        :loading="is_loading_sources"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                    <v-text-field v-model="CPA" label="CPA" color="primary" outlined small>
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        v-model="email_cost"
                        label="Стоимость Email"
                        color="primary"
                        outlined
                        small
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <!-- <v-text-field
                        v-model="sms_cost"
                        label="Стоимость SMS"
                        color="primary"
                        outlined
                        small
                >
                </v-text-field> -->
                </v-col>
                <v-col cols="3">
                    <v-btn :disabled="is_loading" color="secondary" @click="get()">Запросить</v-btn>
                </v-col>
            </v-row>
        </form>
        <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            :loading="is_loading"
            loading-text="Загрузка данных"
            class="elevation-1"
            :items-per-page="-1"
        >
            <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{ h.text }}</span>
                    </template>
                    <div style="white-space: pre-line;">{{ h.help }}</div>
                </v-tooltip>
            </template>
            <template v-slot:item.CPA="{ item }">
                <v-text-field v-model="item.CPA"> </v-text-field>
            </template>
            <template v-slot:item.CPAcq="{ item }">
                {{ (item.CPA / item.UA).toFixed(3) }}
            </template>
            <template v-slot:item.CAC="{ item }">
                {{ (item.CPA / item.Buyers1a).toFixed(3) }}
            </template>
            <template v-slot:item.EmailCost="{ item }">
                {{ (item.EmailCount * email_cost).toFixed(2) }}
            </template>
            <template v-slot:item.EmailChainCost="{ item }">
                {{ (item.EmailChain * email_cost).toFixed(2) }}
            </template>
            <template v-slot:item.ARPUCPA="{ item }">
                {{ (item.ARPU - (item.CPA / item.UA).toFixed(3)).toFixed(3) }}
            </template>
            <template v-slot:item.ROI="{ item }">
                {{
                    (
                        (item.Revenue /
                            (parseInt(item.CPA) +
                                item.EmailCount * email_cost +
                                item.SmsCount * sms_cost)) *
                        100
                    ).toFixed(3)
                }}
            </template>
            <template v-slot:item.Profit="{ item }">
                {{
                    (
                        item.Revenue -
                        (parseInt(item.CPA) +
                            item.EmailCount * email_cost +
                            item.SmsCount * sms_cost)
                    ).toFixed(2)
                }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";

export default {
    $_veeValidate: {
        validator: "new",
    },
    components: {
        TimePicker,
    },
    name: "UnitEconomics",
    data() {
        return {
            start: new Date().toISOString().substr(0, 10),
            end: new Date().toISOString().substr(0, 10),
            cohors: 1,
            utm_source: "",
            utm_sources: [],
            currency_list: [],
            email_cost: 0.01,
            sms_cost: 1,
            CPA: 100,
            is_loading: false,
            is_loading_sources: false,
            headers: [
                {
                    text: "utm_source",
                    sortable: false,
                    value: "utm_source",
                    help: "utm_source",
                },
                {
                    text: "CPA",
                    sortable: false,
                    value: "CPA",
                    help: "Cost Per Acquisition (Стоимость привлечения пользователей)",
                    width: "70px",
                },
                {
                    text: "CPAcq",
                    sortable: false,
                    value: "CPAcq",
                    help: "Стоимость привлечения пользователя.\n CPAcq = CPA / UA",
                },
                {
                    text: "CAC",
                    sortable: false,
                    value: "CAC",
                    help:
                        "Customer Acquisition Costs (Стоимость привлечения платящего)\nСтоимость привлечения платящего пользователя.\nCAC = CPA / Buyers1a",
                },
                {
                    text: "UA",
                    sortable: false,
                    value: "UA",
                    help:
                        "users or Lead Acquisition (Поток пользователей)\nколичество новых зарегистрированных клиентов с даты накала до даты окончания",
                },
                {
                    text: "P",
                    sortable: false,
                    value: "P",
                    help: "Количество заявок по данным клиентам",
                },
                {
                    text: "A",
                    sortable: false,
                    value: "A",
                    help: "Количество выдач нам денег по данным клиентам",
                },
                {
                    text: "Revenue",
                    value: "Revenue",
                    help: "Сколько денег мы получили за указанное время",
                },
                {
                    text: "Email",
                    sortable: false,
                    value: "EmailCount",
                    help: "Количество отправленных всего сообщений этим клиентам",
                },
                {
                    text: "EmailChain",
                    sortable: false,
                    value: "EmailChain",
                    help: "Количество отправленных сообщений на данных клиентов в цепочке",
                },
                {
                    text: "Email$",
                    sortable: false,
                    value: "EmailCost",
                    help: "Cколько мы потратили денег на отправку всех емейлов",
                },
                {
                    text: "EmailChain$",
                    sortable: false,
                    value: "EmailChainCost",
                    help: "Cколько мы потратили денег на отправку емейлов на цепочку",
                },
                {
                    text: "Sms",
                    sortable: false,
                    value: "SmsCount",
                    help: "Количество отправленных всего сообщений этим клиентам",
                },
                {
                    text: "SmsChain",
                    sortable: false,
                    value: "SmsChain",
                    help: "Количество отправленных сообщений на данных клиентов в цепочке",
                },
                {
                    text: "Sms$",
                    sortable: false,
                    value: "SmsCost",
                    help: "Cколько мы потратили денег на отправку всех сообщений",
                },
                {
                    text: "SmsChain$",
                    sortable: false,
                    value: "SmsChainCost",
                    help: "Cколько мы потратили денег на отправку сообщений на цепочку",
                },
                {
                    text: "Push",
                    sortable: false,
                    value: "Push",
                    help: "это кол-во отправленных пушей на данных клиентов",
                },
                {
                    text: "OW",
                    sortable: false,
                    value: "OW",
                    help: "Cколько было показов офферов всего пользователям",
                },
                {
                    text: "OWC",
                    sortable: false,
                    value: "OWC",
                    help: "Cколько было показов офферов на одного пользователя.\nOWС = OW / UA",
                },
                {
                    text: "ClOf",
                    sortable: false,
                    value: "ClOf",
                    help: "Cколько кликов по офферам было всего по данным пользователям",
                },
                {
                    text: "ClOfС",
                    sortable: false,
                    value: "ClOfС",
                    help: "колько кликов по офферам на каждого пользователя\nClOfС = ClOf / UA",
                },
                {
                    text: "C1p",
                    sortable: false,
                    value: "C1p",
                    help:
                        "это конверсия в первую заявку на займ\nС1a = Кол-во первых заявок с выбранных клиентов / UA",
                },
                {
                    text: "C2p",
                    sortable: false,
                    value: "C2p",
                    help:
                        "это конверсия во вторую заявку на займ\nС2a = Кол-во вторых заявок с выбранных клиентов / UA",
                },
                {
                    text: "C1a",
                    sortable: false,
                    value: "C1a",
                    help:
                        "это конверсия в первую выдачу денег НАМ\nС1p = = Кол-во первых аппрувов с выбранных клиентов / UA",
                },
                {
                    text: "C2a",
                    sortable: false,
                    value: "C2a",
                    help:
                        "это конверсия во вторую выдачу денег НАМ\nС2p = Кол-во вторых аппрувов с выбранных клиентов / UA",
                },
                {
                    text: "Buyers1p",
                    sortable: false,
                    value: "Buyers1p",
                    help: "количество пользователей, оставляющих 1ую заявку",
                },
                {
                    text: "Buyers2p",
                    sortable: false,
                    value: "Buyers2p",
                    help: "количество пользователей, оставляющих 2ую заявку",
                },
                {
                    text: "Buyers1a",
                    sortable: false,
                    value: "Buyers1a",
                    help: "количество пользователей, за которых мы получили деньги в первый раз",
                },
                {
                    text: "Buyers2a",
                    sortable: false,
                    value: "Buyers2a",
                    help: "количество пользователей, за которых получили деньги второй раз",
                },
                {
                    text: "PFU",
                    sortable: false,
                    value: "PFU",
                    help:
                        "(Pending For the users)\nэто количество заявок на одного пользователя\nPFU = А / UA",
                },
                {
                    text: "AFU",
                    sortable: false,
                    value: "AFU",
                    help:
                        "(Approved For the users)\nэто количество выдач нам денег на одного пользователя\nAFU = А / UA",
                },
                {
                    text: "ARPU",
                    sortable: false,
                    value: "ARPU",
                    help:
                        "это сколько нам приносит денег, каждый зарегистрированный\nARPU = Revenue / UA",
                },
                {
                    text: "ARPPU",
                    sortable: false,
                    value: "ARPPU",
                    help:
                        "(Average Revenue Per Paying users (Прибыль на одного платящего))\nэто сколько нам приносит денег каждый кто приносит деньги\nARPPU = Revenue / Buyers1p",
                },
                {
                    text: "CLTVp",
                    sortable: false,
                    value: "CLTVp",
                    help: "это сколько нам приносит каждая заявка\nCLTVp = Revenue / P",
                },
                {
                    text: "CLTVa",
                    sortable: false,
                    value: "CLTVa",
                    help: "это сколько нам приносит каждый аппрув\nCLTVa = Revenue / AP",
                },
                {
                    text: "AvPen",
                    sortable: false,
                    value: "AvPen",
                    help: "это число заявок на пользователя\nAvPen = P / UA",
                },
                {
                    text: "AvApp",
                    sortable: false,
                    value: "AvApp",
                    help: "это число выдач нам денег на пользователя\nAvApp = A / UA",
                },
                {
                    text: "ARPU-CPAcq",
                    sortable: false,
                    value: "ARPUCPA",
                    help: "Профит от каждого зарегистрированного\nARPU-CPAcq = ARPU-CPAcq",
                },
                {
                    text: "ROI",
                    sortable: false,
                    value: "ROI",
                    help:
                        "Return On Investment (Показатель окупаемости)\nROI = (Revenue / (CPA+SMS$+Email$)) * 100%",
                },
                {
                    text: "Profit",
                    sortable: false,
                    value: "Profit",
                    help: "Сколько денег мы заработали\n Revenue - (CPA+SMS$+Email$)",
                },
            ],
            items: [],
        };
    },
    created() {
        this.get_currency_list();
    },
    methods: {
        get() {
            if (this.utm_source.length != 0) {
                const params = {
                    start: this.start,
                    end: this.end,
                    cohors: this.cohors,
                    utm_source: this.utm_source,
                    currency_list: this.currency_list,
                    CPA: this.CPA,
                };
                this.is_loading = true;
                this.$store
                    .dispatch("GET_ECONOMICS", params)
                    .then((data) => {
                        this.items = [];
                        this.items = data.data.stat;
                        console.log("execution time " + data.data.execution_time);
                    })
                    .catch((error) => {
                        this.$toaster.error(error);
                    })
                    .finally(() => {
                        this.is_loading = false;
                    });
            } else {
                this.$toaster.error("Выберите хотябы один UTM_SOURCE");
            }
        },
        get_utm_sources() {
            const params = {
                start: this.start,
                end: this.end,
            };
            this.is_loading_sources = true;
            this.$store
                .dispatch("GET_UTM_SOURCES", params)
                .then((data) => {
                    this.utm_sources = data.data;
                })
                .catch((error) => {
                    this.$toaster.error(error);
                })
                .finally(() => {
                    this.is_loading_sources = false;
                });
        },
        get_currency_list() {
            this.$store
                .dispatch("GET_CURRENCY_LIST")
                .then((data) => {
                    this.currency_list = data.data;
                })
                .catch((error) => {
                    this.$toaster.error(error);
                })
                .finally(() => {});
        },
    },
    watch: {
        start: function (val) {
            this.get_utm_sources();
        },
        end: function (val) {
            this.get_utm_sources();
        },
    },
};
</script>
